import { type TypedDocumentNode, gql } from '@apollo/client';
import styled from 'styled-components';

import { Horizontal, Vertical } from 'atoms/layout/flex';
import { useIsLaptop } from 'hooks/device/useIsLaptop';

import { CreateATeam } from './CreateATeam';
import { Hero } from './Hero';
import { LevelUp } from './LevelUp';
import { Navbar } from './Navbar';
import { OurCompetitions } from './OurCompetitions';
import { ScorePoints } from './ScorePoints';
import { ScoutAndCollect } from './ScoutAndCollect';
import { WinRewards } from './WinRewards';
import { YourBudget } from './YourBudget';
import type { HowToPlay_card } from './__generated__/index.graphql';

const NavbarContainer = styled(Horizontal).attrs({ center: true })`
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 5;
  width: 85%;
`;
export const HowToPlay = ({ cards }: { cards: HowToPlay_card[] }) => {
  const isLaptopAndAbove = useIsLaptop();
  return (
    <Vertical gap={0}>
      {!!isLaptopAndAbove && (
        <NavbarContainer>
          <Navbar />
        </NavbarContainer>
      )}
      <Hero cards={cards} />
      <ScoutAndCollect />
      <OurCompetitions />
      <CreateATeam />
      <ScorePoints card={cards[2]} />
      <WinRewards />
      <LevelUp />
      <YourBudget />
    </Vertical>
  );
};

HowToPlay.fragments = {
  card: gql`
    fragment HowToPlay_card on Card {
      slug
      ...Hero_card
      ...ScorePoints_card
    }
    ${Hero.fragments.card}
    ${ScorePoints.fragments.card}
  ` as TypedDocumentNode<HowToPlay_card>,
};
